module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qa-main"
  }, [_c('div', {
    staticClass: "qa"
  }, _vm._l((_vm.sections), function(section) {
    return _c('div', {
      key: section.title,
      staticClass: "qa-section"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _vm._l((section.items), function(item) {
      return [_c('p', {
        key: item.question,
        staticClass: "ask"
      }, [_vm._v(_vm._s(item.question))]), _vm._v(" "), _c('p', {
        key: item.answer,
        staticClass: "answer"
      }, [_vm._v(_vm._s(item.answer))])]
    })], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaf76d3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Qa.vue
// module id = 627
// module chunks = 1